<template>
    <div
        class="flex items-center hover:text-primary cursor-pointer underline"
        @click="() => download(params.data)"
    >
        <i :class="getFileIcon(params.data.documentMeta.contentType)" class="mr-1"/>
        {{ params.data.documentMeta.filename }}
    </div>
</template>

<script setup lang="ts">
import { download } from '@/services/infrastructure/storage.service'

defineProps({
    params: {
        type: Object as () => any,
        required: true
    }
})

const getFileIcon = (contentType: string) => {
    if (contentType === 'application/xml') {
        return 'i-mdi-xml'
    } else if (contentType === 'text/csv') {
        return 'i-mdi-file-csv'
    }
}

</script>

<style scoped>

</style>